module.exports = __webpack_public_path__ + "img/118.12bc5f20.svg";